import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';

export interface WhiteListedDiff {
    path: string;
    metadata: any;
}

/**
 * A small utility to check for deep equality for session data response.
 * This does not cover all the edge cases which might be present in a regular JS deep equality check and makes some assumptions to keep it very lite:
 * a) No circular reference of objects should be present
 * b) Does not check for functions
 * c) Does not check for Date objects
 * @param object1 Object 1 to check
 * @param object2 Object 2 to check
 */
export function checkForWhiteListedDiff(
    object1: OwaUserConfiguration,
    object2: OwaUserConfiguration,
    whiteListedObject: any,
    currentPath: string = '',
    useParentWhitelistedObject: boolean = false
): {
    diffs: WhiteListedDiff[];
} {
    // If object references are same or value is same, then both are equal
    if (object1 === object2) {
        return {
            diffs: [],
        };
    }

    if (!whiteListedObject && !useParentWhitelistedObject) {
        return {
            diffs: [],
        };
    }

    let diffResults: WhiteListedDiff[] = [];

    if (
        typeof object1 === 'object' &&
        typeof object2 === 'object' &&
        object1 !== null &&
        object2 !== null
    ) {
        const object1Keys = Object.keys(object1);
        const object2Keys = Object.keys(object2);

        // If the length of keys are different, no point checking for any keys.
        if (
            Array.isArray(object1) &&
            Array.isArray(object2) &&
            object1Keys.length !== object2Keys.length
        ) {
            diffResults.push({
                path: currentPath,
                metadata: whiteListedObject,
            });
        }

        for (let index = 0; index < object1Keys.length; index++) {
            const currentKey = object1Keys[index];
            const path = currentPath ? currentPath + '.' + currentKey : currentKey;

            const arrayFoundCurrent = !useParentWhitelistedObject
                ? Array.isArray(object1) && Array.isArray(object2)
                : useParentWhitelistedObject;
            const whiteListedObjectNext = whiteListedObject[currentKey]
                ? whiteListedObject[currentKey]
                : arrayFoundCurrent
                ? whiteListedObject
                : null;
            const deepEqualCheckForKey = checkForWhiteListedDiff(
                object1[currentKey],
                object2[currentKey],
                whiteListedObjectNext,
                path,
                arrayFoundCurrent
            );
            if (deepEqualCheckForKey.diffs.length) {
                diffResults = diffResults.concat(...deepEqualCheckForKey.diffs);
            }
        }
    } else {
        diffResults.push({
            path: currentPath,
            metadata: whiteListedObject,
        });
    }

    return { diffs: diffResults };
}
